import React from 'react';
import { Alert } from 'antd';
import { UnorderedListOutlined, BorderOutlined } from '@ant-design/icons';

/**
 * ProfileCompletionAlert - A reusable alert component for profile completion
 * 
 * @param {Object} props
 * @param {string} props.title - The title text
 * @param {ReactNode} props.icon - Optional custom icon (defaults to UnorderedListOutlined)
 * @param {string[]} props.items - Array of items to display with checkboxes
 * @param {string} props.footerText - Optional footer text/instruction
 * @param {string} props.variant - 'success' (green) or 'error' (red), defaults to 'success'
 * @param {boolean} props.closable - Whether to show close button
 * @param {Function} props.onClick - Optional click handler for the entire alert
 */
const ProfileCompletionAlert = ({ 
  title, 
  icon, 
  items = [], 
  footerText,
  variant = 'success',
  closable = false,
  onClick 
}) => {
  const isSuccess = variant === 'success';
  const iconColor = isSuccess ? '#52c41a' : '#ff4d4f';
  const textColor = isSuccess ? '#52c41a' : '#ff4d4f';
  
  const defaultIcon = icon || <UnorderedListOutlined style={{ fontSize: '16px' }} />;
  
  const alertStyle = onClick ? { cursor: 'pointer' } : {};
  
  return (
    <div style={alertStyle} onClick={onClick}>
      <Alert
        message={
          <span style={{ 
            display: 'inline-flex', 
            alignItems: 'baseline',
            fontWeight: 'bold',
            lineHeight: '1.5'
          }}>
            <span style={{ 
              display: 'inline-flex', 
              alignItems: 'baseline',
              marginRight: '8px',
              color: iconColor,
              lineHeight: '1.5'
            }}>
              {defaultIcon}
            </span>
            <span style={{ lineHeight: '1.5' }}>{title}</span>
          </span>
        }
        description={
          <div>
            {items.length > 0 && (
              <ul style={{ margin: '8px 0', paddingLeft: '20px', listStyle: 'none' }}>
                {items.map((item, index) => (
                  <li key={index} style={{ 
                    color: textColor,
                    display: 'flex',
                    alignItems: 'flex-start',
                    marginBottom: '4px',
                    lineHeight: '1.5'
                  }}>
                    <span style={{ 
                      display: 'inline-flex',
                      alignItems: 'center',
                      marginRight: '8px',
                      marginTop: '2px',
                      flexShrink: 0
                    }}>
                      <BorderOutlined 
                        style={{ 
                          color: textColor, 
                          fontSize: '14px',
                          opacity: 0.8
                        }} 
                      />
                    </span>
                    <span style={{ flex: 1 }}>{item}</span>
                  </li>
                ))}
              </ul>
            )}
            {footerText && (
              <div style={{ color: textColor, fontWeight: 500, marginTop: '8px' }}>
                {footerText}
              </div>
            )}
          </div>
        }
        type={variant}
        showIcon={false}
        closable={closable}
      />
    </div>
  );
};

export default ProfileCompletionAlert;

